module.exports = __webpack_public_path__ + "static/right_border-26d927e94670a8e8af31867c813109e8.png";